<div class="icon-container">
  <span
    class="material-symbols-rounded"
    [ngStyle]="{
      fontSize: iconSize,
      color: iconColor,
      height: '100%',
      width: '100%'
    }"
    >{{ iconName }}</span
  >
</div>
